import React from "react";
import { Gift } from "lucide-react";

// Tiny animated gift box — lid wiggle + gold pulse
export const MiniGiftBox = ({ size = 22, className = "" }) => (
  <span
    className={`gg-gift-glow inline-flex items-center justify-center rounded-full flex-shrink-0 ${className}`}
    style={{ width: size, height: size, background: "linear-gradient(135deg,#F4D58D,#C5985A)" }}
    data-testid="mini-gift-box"
  >
    <Gift size={Math.round(size * 0.58)} strokeWidth={2.4} className="text-plum gg-gift-lid" />
  </span>
);

export const GiftHighlight = ({ text, testId }) => (
  <span
    className="inline-flex items-center gap-2 pl-1 pr-3 py-1 rounded-full text-[10px] tracking-[0.22em] uppercase font-bold"
    style={{
      background: "linear-gradient(90deg, rgba(244,213,141,0.22), rgba(244,213,141,0.08))",
      border: "1px solid rgba(244,213,141,0.6)",
      color: "#F4D58D",
    }}
    data-testid={testId}
  >
    <MiniGiftBox size={22} />
    {text}
  </span>
);

export default MiniGiftBox;
